// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.nav a {
    text-decoration: none;
    color: #72777c;
}

.search-criteria-container {
    margin-top: 3px;
    padding: 0 0 10px 0;
    color: #72777c;
    margin-bottom: 24px;
}
    .search-criteria-container .search-term {
        padding: 6px 6px 6px 8px;
        font-size: 0.9rem;
        background-color: #ecedef;
        margin-bottom: 10px;
    }

    .search-criteria-container .sc-card {
        position: relative;
    }

    .search-criteria-container span.term {
        display: inline-block;
        width: 88%;
    }

    .search-criteria-container span.icon {
        position: absolute;
        top: 0;
        right:0;
        cursor: pointer;
    }

#distance:disabled {
    cursor: not-allowed;
}


/* Medium-Large screens */
@media only screen and (min-width: 768px) {
    .container.search-container {
        padding: 10px 0;
    }

    nav {
        border-bottom: none;
    }

    .nav {
        border-bottom: 1px solid var(--main-color);
    }

    .nav-item.nav-link.active {
        border: 1px solid var(--main-color);
        border-bottom: none;
        color: #000;
    }

    .nav-item.nav-link.search-tab {
        border-left: none;
    }
}

@media only screen and (width: 768px) {
    .form-group input {
        font-size: 0.7rem;
        padding-left: 5px;
    }
    ::ng-deep .form-group input {
        font-size: 0.7rem;
        padding-left: 5px;
    }

    ::ng-deep .form-group select {
        font-size: 0.7rem;
        padding-left: 5px;
    }

    .search-tab {
        border-bottom: none;
    }
}

@media only screen and (max-width: 767px) {

    .search-criteria-container {
        padding: 0 0 10px 0;
    }

    .nav {
        border: none;
        text-align: center;
    }

    .nav-item.nav-link {
        border: none;
        background-color: #E7E9EC;
        width: 47%;
        text-align: center;
        margin: 0 1.5%;
    }

        .nav-item.nav-link.active {
            color: #000;
            background-color: #fff;
            border: 1px solid var(--main-color);
        }
    a#nav-search-tab {
        margin-left: 0;
    }
    a#nav-sort-tab {
        margin-right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/search/searchForm/searchForm.component.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;IACI;QACI,wBAAwB;QACxB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,eAAe;IACnB;;AAEJ;IACI,mBAAmB;AACvB;;;AAGA,yBAAyB;AACzB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,mCAAmC;QACnC,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,yBAAyB;QACzB,UAAU;QACV,kBAAkB;QAClB,cAAc;IAClB;;QAEI;YACI,WAAW;YACX,sBAAsB;YACtB,mCAAmC;QACvC;IACJ;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["\r\n.nav a {\r\n    text-decoration: none;\r\n    color: #72777c;\r\n}\r\n\r\n.search-criteria-container {\r\n    margin-top: 3px;\r\n    padding: 0 0 10px 0;\r\n    color: #72777c;\r\n    margin-bottom: 24px;\r\n}\r\n    .search-criteria-container .search-term {\r\n        padding: 6px 6px 6px 8px;\r\n        font-size: 0.9rem;\r\n        background-color: #ecedef;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .search-criteria-container .sc-card {\r\n        position: relative;\r\n    }\r\n\r\n    .search-criteria-container span.term {\r\n        display: inline-block;\r\n        width: 88%;\r\n    }\r\n\r\n    .search-criteria-container span.icon {\r\n        position: absolute;\r\n        top: 0;\r\n        right:0;\r\n        cursor: pointer;\r\n    }\r\n\r\n#distance:disabled {\r\n    cursor: not-allowed;\r\n}\r\n\r\n\r\n/* Medium-Large screens */\r\n@media only screen and (min-width: 768px) {\r\n    .container.search-container {\r\n        padding: 10px 0;\r\n    }\r\n\r\n    nav {\r\n        border-bottom: none;\r\n    }\r\n\r\n    .nav {\r\n        border-bottom: 1px solid var(--main-color);\r\n    }\r\n\r\n    .nav-item.nav-link.active {\r\n        border: 1px solid var(--main-color);\r\n        border-bottom: none;\r\n        color: #000;\r\n    }\r\n\r\n    .nav-item.nav-link.search-tab {\r\n        border-left: none;\r\n    }\r\n}\r\n\r\n@media only screen and (width: 768px) {\r\n    .form-group input {\r\n        font-size: 0.7rem;\r\n        padding-left: 5px;\r\n    }\r\n    ::ng-deep .form-group input {\r\n        font-size: 0.7rem;\r\n        padding-left: 5px;\r\n    }\r\n\r\n    ::ng-deep .form-group select {\r\n        font-size: 0.7rem;\r\n        padding-left: 5px;\r\n    }\r\n\r\n    .search-tab {\r\n        border-bottom: none;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n\r\n    .search-criteria-container {\r\n        padding: 0 0 10px 0;\r\n    }\r\n\r\n    .nav {\r\n        border: none;\r\n        text-align: center;\r\n    }\r\n\r\n    .nav-item.nav-link {\r\n        border: none;\r\n        background-color: #E7E9EC;\r\n        width: 47%;\r\n        text-align: center;\r\n        margin: 0 1.5%;\r\n    }\r\n\r\n        .nav-item.nav-link.active {\r\n            color: #000;\r\n            background-color: #fff;\r\n            border: 1px solid var(--main-color);\r\n        }\r\n    a#nav-search-tab {\r\n        margin-left: 0;\r\n    }\r\n    a#nav-sort-tab {\r\n        margin-right: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
